import { i18n } from '../services/i18n.js';
import { icon } from '../services/icons.js';

export const HomeView = container => {
  container.innerHTML = `
    <div class="home-v2">
      <section class="home-hero-v2">
        <div class="container home-hero-grid">
          <div class="home-hero-copy">
            <span class="home-eyebrow">${icon('sparkles')} ${i18n.t('home_eyebrow')}</span>
            <h1>${i18n.t('home_title')}</h1>
            <p>${i18n.t('home_subtitle')}</p>
            <div class="home-hero-actions">
              <a href="#/login" class="btn btn-primary btn-lg">${i18n.t('start_free')} ${icon('arrowRight')}</a>
              <button id="homeHowButton" type="button" class="btn btn-secondary btn-lg">${i18n.t('how_it_works')}</button>
            </div>
            <div class="home-trust-line">
              <span>${icon('check')} ${i18n.t('home_no_install')}</span>
              <span>${icon('check')} ${i18n.t('home_try_first')}</span>
            </div>
          </div>
          <div class="home-product-preview" aria-label="${i18n.t('home_image_alt')}">
            <div class="preview-topbar"><span class="preview-brand">${icon('heart')} Heart150</span><span class="preview-live"><i></i> LIVE</span></div>
            <div class="preview-question"><small>${i18n.t('question')} 3 / 8</small><strong>${i18n.t('home_demo_question')}</strong></div>
            <div class="preview-answers"><span>A</span><span>B</span><span>C</span><span>D</span></div>
            <div class="preview-footer"><div class="preview-players"><i>AN</i><i>MK</i><i>HL</i><b>+21</b></div><strong>${icon('bolt')} 24 ${i18n.t('players')}</strong></div>
          </div>
        </div>
      </section>

      <section class="home-problem-v2">
        <div class="container home-problem-grid">
          <div><span class="home-section-number">01</span><h2>${i18n.t('home_pain_title')}</h2><p>${i18n.t('home_pain')}</p></div>
          <div class="home-problem-arrow">${icon('arrowRight')}</div>
          <div><span class="home-section-number accent">02</span><h2>${i18n.t('home_solution_title')}</h2><p>${i18n.t('home_solution')}</p></div>
        </div>
      </section>

      <section id="how-it-works" class="home-how-v2">
        <div class="container">
          <div class="home-section-head"><span>${i18n.t('how_it_works')}</span><h2>${i18n.t('how_title')}</h2></div>
          <div class="home-steps-v2">
            <article><span class="home-step-icon">${icon('sparkles')}</span><small>01</small><h3>${i18n.t('how_step_1')}</h3><p>${i18n.t('how_step_1_desc')}</p></article>
            <article><span class="home-step-icon">${icon('phone')}</span><small>02</small><h3>${i18n.t('how_step_2')}</h3><p>${i18n.t('how_step_2_desc')}</p></article>
            <article><span class="home-step-icon">${icon('trophy')}</span><small>03</small><h3>${i18n.t('how_step_3')}</h3><p>${i18n.t('how_step_3_desc')}</p></article>
          </div>
        </div>
      </section>

      <section class="home-final-v2"><div class="container"><div><span>${i18n.t('home_final_kicker')}</span><h2>${i18n.t('cta_final')}</h2><p>${i18n.t('cta_final_help')}</p></div><a href="#/login" class="btn btn-primary btn-lg">${i18n.t('start_free')} ${icon('arrowRight')}</a></div></section>
    </div>`;
  container.querySelector('#homeHowButton').addEventListener('click', () => container.querySelector('#how-it-works').scrollIntoView({ behavior: 'smooth' }));
};
